<template>
  <BaseControlBar>
  <!-- <BaseControlBar :back-url="backUrl"> -->
  <div class="d-flex align-items-center flex-grow-1 section-header__title">
      <h1>{{ title }}</h1>
      <StatusLabel v-if="inputVal" :item="status"></StatusLabel>
    </div>
    <div class="admin-group">
      <ButtonReject
        v-if="inputVal && inputVal.status === 'ACTIVATED'"
        @click="prepareAction('DEACTIVATE', '你已停用這個營銷人員')"
      >
        停用
      </ButtonReject>
      <BaseModal
        :loading="loading"
        :ok-title="approval.modal.okTitle"
        :ok-variant="approval.modal.okVariant"
        v-stream:ok-click="onSaleStatusUpdate$"
        :title="approval.modal.title"
        :content="approval.modal.content"
        :is-open="approval.modal.isShow"
        :cancel-title="approval.modal.cancelTitle"
        @cancel-click="approval.modal.isShow = false"
        @hidden="approval.modal.isShow = false"
        size="sm">
      </BaseModal>
      <ActionSuccessModal v-model="actionSuccessModal"></ActionSuccessModal>
    </div>
  </BaseControlBar>
</template>

<script>
import { mapGetters } from 'vuex';
import { tap, switchMap } from 'rxjs/operators';
import controlBarMixin from '@/mixins/control-bar';
import BaseControlBar from '@/components/BaseControlBar.vue';
import BaseModal from '@/components/BaseActionModal.vue';
import ActionSuccessModal from '@/components/ActionSuccessModal.vue';
import ButtonReject from '@/components/button/ButtonReject.vue';
import getStatus from '@/helpers/status';
import StatusLabel from '@/components/StatusLabel.vue';
import http from '@/helpers/http';

export default {
  mixins: [controlBarMixin],
  components: {
    BaseControlBar,
    StatusLabel,
    ButtonReject,
    BaseModal,
    ActionSuccessModal,
  },
  props: {
    title: String,
  },
  data: () => ({
    loading: false,
    approval: {
      modal: {
        title: '',
      },
      action: null,
    },
    actionSuccessModal: {
      show: false,
      action: null,
      msg: null,
      back: {
        location: '/admin/sales',
        text: '營銷人員列表',
      },
    },
  }),
  computed: {
    ...mapGetters(['role']),
    backUrl() {
      return `/${this.role}/sales`;
    },
    status() {
      return getStatus(this.inputVal);
    },
  },
  domStreams: ['onSaleStatusUpdate$'],
  subscriptions() {
    return {
      saleStatusUpdate: this.onSaleStatusUpdate$.pipe(
        tap(() => {
          this.loading = true;
        }),
        switchMap(() => {
          const { action, msg } = this.approval;
          return http(
            {
              method: 'POST',
              url: `/agc-${this.role}-api/sales/${action.toLowerCase()}`,
              data: {
                saleId: this.inputVal.id,
              },
            },
            {
              next: (status) => {
                this.inputVal.status = status;
                if (msg) {
                  this.actionSuccessModal = {
                    ...this.actionSuccessModal,
                    show: true,
                    action,
                    msg,
                  };
                }
              },
              complete: () => {
                this.approval.modal.isShow = false;
                this.loading = false;
              },
            },
          );
        }),
      ),
    };
  },
  methods: {
    async prepareAction(action, msg) {
      if (action === 'DEACTIVATE') {
        this.approval = {
          modal: {
            isShow: true,
            title: '確定停用此營銷人員？',
            okVariant: 'danger',
          },
          action,
          msg,
        };
      }
    },
  },
};
</script>

<style scoped lang="scss">
.admin-group {
  display: flex;
}
</style>
